import React from 'react';

interface ResponsiveCardListProps<T> {
  items: T[];
  /** Stable React key for each item. */
  keyField: (item: T) => React.Key;
  /** Renders the mobile card body for a single item. */
  renderCard: (item: T) => React.ReactNode;
  className?: string;
}

/**
 * ResponsiveCardList
 *
 * Mobile-only (<md) stacked card list used to replace horizontal-scrolling
 * tables on bespoke pages (operations, reports). Pair it with the existing
 * `<table>` wrapped in `hidden md:block` so desktop keeps the table and mobile
 * gets tappable cards. This component renders nothing at md and up.
 */
function ResponsiveCardList<T>({
  items,
  keyField,
  renderCard,
  className = '',
}: ResponsiveCardListProps<T>) {
  return (
    <div className={`md:hidden divide-y divide-gray-200 ${className}`}>
      {items.map((item) => (
        <div key={keyField(item)} className="p-4">
          {renderCard(item)}
        </div>
      ))}
    </div>
  );
}

export default ResponsiveCardList;
